<template>
    <v-app class="">
        <div class="p-0 pt-5 mt-5 col-md-8 mx-auto" style="border: none!important;">
            <p class="mt-5">تعرفه موردنظر خود را با پرکردن تمامی فیلدهای درخواستی ایجاد کنید.</p>
            <v-row class="mt-5">
                <v-col cols="12" md="6">
                    <v-text-field
                            label="نام تعرفه"
                            required
                            dense
                            outlined
                            class="mt-1"
                            prepend-inner-icon="fa fa-pencil-alt"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-autocomplete
                            label="انتخاب سرویس"
                            required
                            dense
                            outlined
                            class="mt-1"
                            prepend-inner-icon="fa fa-pencil-alt"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                    <v-autocomplete
                            label="انتخاب فرم سفارش"
                            required
                            dense
                            outlined
                            class="mt-1"
                            prepend-inner-icon="fa fa-pencil-alt"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                    <v-file-input
                            label="آپلود فایل پی دی اف"
                            required
                            v-model="icon"
                            prepend-icon=""
                            dense
                            @change="submitFiles"
                            outlined
                            prepend-inner-icon="mdi-paperclip"
                            class="mt-1"
                    ></v-file-input>
                    <v-progress-linear
                            v-if="progressPercent!== '' "
                            class="mx-auto"
                            :value="progressPercent"
                            color="indigo"
                    >
                    </v-progress-linear>
                </v-col>
            </v-row>
            <div class="col-md-12 text-left">
                <v-btn class="float-left submit-btn">
                    <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                    ثبت تعرفه
                </v-btn>
            </div>
        </div>
    </v-app>
</template>

<script>
export default {
    name: "create",
    data() {
        return {
            progressPercent: '',
            icon:''
        }
    },
    methods:{
        submitFiles() {
            if (this.icon === '' || this.icon === null)
                return;

            let formData = new FormData();
            formData.append('file', this.icon);

            this.requestApiPost('/upload/file', formData, {
                onUploadProgress: (response) => {
                    const {loaded, total} = response;
                    let percent = Math.floor((loaded * 100) / total)
                    this.progressPercent = percent

                }
            }).then((x) => {
                this.$modal.success('موفق!', x.data.message);
                this.progressPercent = '';

            }).catch((error) => {
                this.$modal.error('خطا!', error.response.data.errors.file[0])
                this.progressPercent = '';
            });
        }
    }
}
</script>

<style>
.fa-pencil-alt {
    font-size: 1.3rem !important;
}
</style>